import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import LeadAppResource from './LeadAppResource';

class LeadDispositionAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Lead-Disposition';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'leads/dispositions';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'leadQualificationStatus',
            'reason',
            'notes',
            'leadUuid',
            'lead',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            lead: LeadAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            lead: 'lead_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            leadQualificationStatus: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            reason: {
                type: 'string',
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            notes: {
                type: 'string',
                length: {
                    minimum: 1,
                },
            },
            leadUuid: {
                type: 'string',
                presence: true,
            },
        };
    }

}

export default LeadDispositionAppResource;
